import { z } from 'zod';

import { DiagramPositionSchema } from './DiagramPosition.schema';
import { FileSchema } from './File.schema';

export const DiagramImageSchema = z.object({
    id: z.string(),
    position: DiagramPositionSchema,
    dimensions: z.object({
        width: z.number(),
        height: z.number(),
    }),
    file: FileSchema.shape.id,
});
